'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _Html = require('@/libs/renderers/Html');

var _Html2 = _interopRequireDefault(_Html);

var _MessageParser = require('@/libs/MessageParser');

var _MessageParser2 = _interopRequireDefault(_MessageParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            pluginUiSections: _GlobalApi2.default.singleton().aboutBufferPlugins,
            closedSections: {}
        };
    },

    computed: {
        b: function b() {
            return this.buffer || {};
        },
        formattedTopic: function formattedTopic() {
            var blocks = (0, _MessageParser2.default)(this.b.topic || '', { extras: false });
            var content = (0, _Html2.default)(blocks);
            return content;
        },
        highlights: function highlights() {
            var tmp = this.buffer.message_count;
            return this.buffer.getMessages().filter(function (m) {
                return m.isHighlight;
            }).filter(function (m) {
                return m.type !== 'traffic';
            }).filter(function (m) {
                return m.type !== 'topic';
            }).filter(function (m) {
                return m.type !== 'mode';
            }).filter(function (m) {
                return m.html;
            }).sort(function (a, b) {
                return b.time - a.time;
            });
        }
    },
    methods: {
        toggleSection: function toggleSection(section) {
            this.$set(this.closedSections, section, !this.closedSections[section]);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarAboutBuffer"]
window._kiwi_exports.components.SidebarAboutBuffer = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SidebarAboutBuffer.vue
// module id = TbYc
// module chunks = 1